<template>
    <div>
        <LoadingComponent v-show="pageLoading"></LoadingComponent>
        <div v-if="activityData" :class="[dialogData && 'filter-show']">
            <router-view :activityData="activityData" :baseData="baseData" />
        </div>
        <base-component :baseData="baseData" v-if="baseData"></base-component>
        <dialog-component v-if="dialogData" :baseData="baseData" />
        <toast-component></toast-component>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import BaseComponent from '@/components/Base.vue'
import DialogComponent from '@/components/Dialog.vue'
import LoadingComponent from "@/components/Loading"
import ToastComponent from "@/components/Toast"
import COVERAPP from "@/utils/COVERAPP";
import COVER from "@/utils/COVER";
import Moment from 'moment'

export default {
    data() {
        return {
            isApp: false,
            baseData: ''
        }
    },
    created() {
        // sessionStorage.setItem('COVER_USERINFO', '{"device_id":"c7f6c86e-a6ab-3a21-bbd3-8e9c2ff22673-ECYA","push_id":"77a7a24f80ed476a9573149b671e36f9","status":"success","account_id":0,"age":0,"avatar":"https://testcdn.thecover.cn/aeb6c87a-56a1-4fc4-a175-45301ac51ec6","birthday":0,"city":"","email":"","gender":"null","integral_sum":0,"is_lock":false,"is_news":false,"is_qq":false,"is_unique_way":false,"is_wechat":false,"is_weibo":false,"label_kind":0,"mobile":"15528293060","nickname":"我们最可爱最可爱的小可爱啦啦嘞","register_way":9,"token":"fc6e37c9977b436090f7ab216aa4fd8a","user_id":49005819,"user_name":"15528293060","origin":"app"}')
        // sessionStorage.setItem('COVER_USERINFO', '{"openid":"o9ZVLwCS4kbIytCAUO1NA4lOwjXQ","nickname":"月","sex":0,"language":"","city":"","province":"","country":"","headimgurl":"https://thirdwx.qlogo.cn/mmopen/vi_32/zuBUib5BL0kiaKzIheQSDZAecenR6WTvI2cUzxXA4p2Yicjm9Wpoia5Y1e8y5fHiaWa5eNjTzsCboOv9UJpw2sggKrQ/132","privilege":[],"unionid":"ob_nkwwgCdvpXGu9bvcTNbT-ZDUA","access_token":"66_nQQeUZ3an9eZu-STLTCo-tXMid7yA3ek1fMhXIhGPlyZgysqtRXzJq-RChfePVcTcefq7dKmUkgpPd3_KDHNtFoFpylQvODlGwY-gwYtCzw","refresh_token":"66_iZgz4oQIrZ_BECtheihYzQuCyBp5Kqcbhw5WgvVMl00GHPTj73uNKjNFKNic_oN24xIwGRPKORksXsnZW_cnu6Wff4OoTUgpfqjgKM1b7k0","origin":"wx","token":"o9ZVLwCS4kbIytCAUO1NA4lOwjXQ"}')
    },
    watch: {
        $route(to, from) {
            document.documentElement.scrollTop = 0
            this.SET_PAGELOADING(true)
            if (to.fullPath != from.fullPath) {
                // if (!this.isApp && !COVERAPP.Attribute.isWeixin()) {
                //     this.SET_DIALOGDATA({
                //         message: '该活动请在微信中打开参加'
                //     })
                // } else {
                this.SET_DIALOGDATA(null)
                // }
                // this.$common.pageLoading()
            }
            if (!from || !from.name) {
                const { id } = this.$route.query
                if (id) {
                    this.SET_AID(id)
                    this.getActDetail().then(() => {
                        // if (this.$route.path !== '/welcome') {
                        //     this.$router.replace({
                        //         path: '/',
                        //         query: {
                        //             id
                        //         },
                        //     });
                        // }
                        COVER.getUser((res) => {
                            res && this.SET_USERINFO(res)
                        })
                    })
                }
            }
        },
        toastData(val) {
            if (val) {
                setTimeout(() => {
                    this.setToastData(null);
                }, 3000);
            }
        },
    },
    computed: {
        ...mapState(['aid', 'pageLoading', 'toastData', 'userInfo', 'shareData', 'dialogData', 'activityData'])
    },
    components: {
        BaseComponent,
        DialogComponent,
        LoadingComponent,
        ToastComponent,
    },
    mounted() {
        this.isApp = COVERAPP.Attribute.isApp()
        window.addEventListener('pageshow', (e) => {
            if (e.persisted) {
                window.location.reload()
            }
        })
    },
    methods: {
        ...mapMutations(['SET_USERINFO', 'SET_SHAREDATA', 'SET_DIALOGDATA', 'SET_ACTIVITYDATA', "SET_AID", "SET_PAGELOADING", 'setToastData']),

        getActDetail() {
            return COVER.$get('/activity/config', {
                aid: this.aid
            }).then(({ data }) => {
                document.title = data.title
                // 设置分享信息
                data.share && this.setShareData(data)
                // 设置活动数据
                this.SET_ACTIVITYDATA(data)
                // 判断活动是否开始
                this.activityStatus(data)
                this.baseData = {
                  isAppShow: data.isAppShow,
                  music: data.music,
                  share: data.share || {},
                  isEnd: data.serverTime >= new Date(data.endTime).getTime(),
                  ...data.openApp,
                }
            })
        },
        activityStatus(data) {
            if (new Date(data.serverTime).getTime() < new Date(data.startTime).getTime()) {
                this.SET_DIALOGDATA({
                    message: `活动尚未开启，请在${Moment(data.startTime).format('YYYY.MM.DD HH:mm:ss')}—${Moment(data.endTime).format('YYYY.MM.DD HH:mm:ss')}时间段内来参与！`
                })
            } else if (new Date(data.serverTime).getTime() > new Date(data.endTime).getTime()) {
                this.SET_DIALOGDATA({
                    message: '活动已结束！'
                })
            } else if (!this.isApp && data.isAppShow) {
                this.SET_DIALOGDATA({
                    message: '参加该活动需在APP中进行',
                    btns: [
                        {
                            text: '取消',
                            className: 'cancel-btn'
                        },
                        {
                            text: '确定',
                            className: 'download-btn'
                        }
                    ]
                })
            }
        },
        setShareData(data) {
            this.SET_SHAREDATA({
                title: data.share.title,
                desc: data.share.desc,
                imgUrl: data.share.imgUrl || 'https://wapcdn.thecover.cn/cdn/wap/img/fengmian_logo.png',
                link: data.share.link || window.location.href
            })
        }
    }
}
</script>

<style>
* {
    box-sizing: border-box;
}

.btn:active {
    filter: brightness(1.5);
}

@keyframes swing {

    20%,
    40%,
    60%,
    80%,
    100% {
        transform-origin: top center
    }

    20% {
        transform: rotate(15deg)
    }

    40% {
        transform: rotate(-10deg)
    }

    60% {
        transform: rotate(5deg)
    }

    80% {
        transform: rotate(-5deg)
    }

    100% {
        transform: rotate(0deg)
    }
}

@-webkit-keyframes swing {

    20%,
    40%,
    60%,
    80%,
    100% {
        -webkit-transform-origin: top center
    }

    20% {
        -webkit-transform: rotate(15deg)
    }

    40% {
        -webkit-transform: rotate(-10deg)
    }

    60% {
        -webkit-transform: rotate(5deg)
    }

    80% {
        -webkit-transform: rotate(-5deg)
    }

    100% {
        -webkit-transform: rotate(0deg)
    }
}

@keyframes pulse {
    0% {
        transform: scale(1)
    }

    50% {
        transform: scale(1.1)
    }

    100% {
        transform: scale(1)
    }
}

@-webkit-keyframes pulse {
    0% {
        -webkit-transform: scale(1)
    }

    50% {
        -webkit-transform: scale(1.1)
    }

    100% {
        -webkit-transform: scale(1)
    }
}
</style>
